/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveCardStatementDocumentRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveCardStatementDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCardStatementDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCardStatementDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveCardStatementDocumentRequest @ squareup/corporate_card/service/retrieve_card_statement_document.proto at 9:1
 */
export const RetrieveCardStatementDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrieveCardStatementDocumentRequest');
fixType(RetrieveCardStatementDocumentRequest);
Builder.createAndAttachToType(RetrieveCardStatementDocumentRequest);
/**
 * SOURCE RetrieveCardStatementDocumentResponse @ squareup/corporate_card/service/retrieve_card_statement_document.proto at 16:1
 */
export const RetrieveCardStatementDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrieveCardStatementDocumentResponse');
fixType(RetrieveCardStatementDocumentResponse);
Builder.createAndAttachToType(RetrieveCardStatementDocumentResponse);